import { useCallback } from 'react';
import useEventHandlersForCreatableDropdowns from '~/modules/common/components/SearchAutocomplete/hooks/useEventHandlersForCreatableDropdowns';

const useRoleDropdownEventHandlers = ({
  openDialog,
  setNewRoleName,
  onValueChange
}) => {
  const openDialogAndSetInitialName = useCallback(
    name => {
      setNewRoleName(name);
      openDialog();
    },
    [openDialog, setNewRoleName]
  );

  const {
    handleOnChange,
    handleOnCancel: onCancel
  } = useEventHandlersForCreatableDropdowns({
    openDialogAndSetInitialName,
    onChange: onValueChange
  });

  return { openDialogAndSetInitialName, handleOnChange, onCancel };
};

export default useRoleDropdownEventHandlers;
